import client from '../httpClient';

const schedulesGetActionDateApi = (divisionId, actionDate) => {
  return client.get(`/schedules/actions/day/${divisionId}?scheduleActionDate=${actionDate}`);
};

export default schedulesGetActionDateApi;
